module.exports = __webpack_public_path__ + "static/media/bra-flag.46e791f7.svg";